import React from "react";
// import "../../assets/icons/iconModification.css";

const Facebook = () => {
  return (
    <div>
      <a
        href="https://www.facebook.com/BharathComputer-110135581694650"
        target="_blank"
      >
        <svg
          className="icons-modification"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          width="30"
          height="30"
          viewBox="0 0 172 172"
        >
          <path d="M0,172v-172h172v172z" fill="none"></path>
          <g fill="#ffffff">
            <path d="M103.68375,6.88c-11.24966,0 -20.96758,3.42947 -27.78875,10.20578c-6.82117,6.77631 -10.535,16.70818 -10.535,28.89735v15.93687h-20.64c-1.89978,0.00019 -3.43981,1.54022 -3.44,3.44v27.52c0.00019,1.89978 1.54022,3.43981 3.44,3.44h20.64v65.36c0.00019,1.89978 1.54022,3.43981 3.44,3.44h27.52c1.89978,-0.00019 3.43981,-1.54022 3.44,-3.44v-65.36h24.08c1.73358,-0.0001 3.19628,-1.29004 3.41313,-3.01l3.44,-27.52c0.1233,-0.97953 -0.18016,-1.96483 -0.83319,-2.70527c-0.65302,-0.74044 -1.59268,-1.16465 -2.57994,-1.16473h-27.52v-13.76c0,-3.84133 3.03867,-6.88 6.88,-6.88h20.64c1.89978,-0.00019 3.43981,-1.54022 3.44,-3.44v-26.33078c-0.00216,-1.72428 -1.28042,-3.18062 -2.98985,-3.40641c-3.03984,-0.40333 -14.01348,-1.22281 -24.0464,-1.22281zM103.68375,13.76c8.38621,0 16.49301,0.67096 20.15625,1.01453v19.62547h-17.2c-7.55883,0 -13.76,6.20117 -13.76,13.76v17.2c0.00019,1.89978 1.54022,3.43981 3.44,3.44h27.06313l-2.58,20.64h-24.48313c-1.89978,0.00019 -3.43981,1.54022 -3.44,3.44v65.36h-20.64v-65.36c-0.00019,-1.89978 -1.54022,-3.43981 -3.44,-3.44h-20.64v-20.64h20.64c1.89978,-0.00019 3.43981,-1.54022 3.44,-3.44v-19.37687c0,-10.81755 3.16585,-18.71456 8.50594,-24.01953c5.34009,-5.30497 13.06243,-8.20359 22.93781,-8.20359z"></path>
          </g>
        </svg>
      </a>
    </div>
  );
};

export default Facebook;
